// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","385":"AgriculturalLand","395":"Partypolicy","516":"MapOverview","721":"PopulationEmployment","777":"ecology","904":"PeopleLivelihood"}[chunkId] + "." + {"177":"a05a2c59","385":"604b0ee9","395":"c8dde9d5","516":"f5b0bc32","721":"e0b4edb0","777":"9d48e57d","904":"b3ced92d"}[chunkId] + ".css";
};